module.exports = __webpack_public_path__ + "static/img/wall-conveyor-perpendicular-steel_256.7823632.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-conveyor-perpendicular-steel_256.png
// module id = PtuR
// module chunks = 0